module.exports = __webpack_public_path__ + "static/IMG-20200827-WA0006-2ed336e6eedc3dbdf4a62e8059b08040.jpg";